import styled, { css } from "styled-components";

export const StyledProgressBarWrapper = styled.div`
	flex: 1;
	display: inline-grid;
	grid-template-columns: repeat(6, minmax(0, 1fr));
	column-gap: 0px;
	flex-direction: row;
	height: 20px;
	background-color: transparent;
	border-radius: ${({ theme: { borderRadius } }) =>
		borderRadius.progressBarLanding};
	box-sizing: border-box;
	margin: 0 auto;
	box-shadow: var(--dz-comp-auth-panel-box-shadow);
	overflow: hidden;
	position: relative;

	${({ totalSteps }) =>
		totalSteps &&
		css`
			grid-template-columns: repeat(${totalSteps}, minmax(0, 1fr));
		`}
`;
